if (!window.anfuluPdpInspectionReady) {
window.anfuluPdpInspectionReady = true;
document.addEventListener('click',function(event){
  const inspect=event.target.closest('[data-af-pdp-inspect]');
  if(inspect){
    event.stopImmediatePropagation();
    const dialog=inspect.closest('.afr').querySelector('.afr__viewer');
    const source=inspect.querySelector('img');
    const image=dialog.querySelector('img');
    image.src=source.src;
    image.alt=source.alt;
    dialog.classList.remove('is-zoomed');
    dialog.querySelector('[data-af-pdp-zoom]').setAttribute('aria-pressed','false');
    dialog.showModal();
    return;
  }
  const close=event.target.closest('[data-af-pdp-close]');
  if(close){event.stopImmediatePropagation();close.closest('dialog').close();return;}
  const zoom=event.target.closest('[data-af-pdp-zoom]');
  if(zoom){event.stopImmediatePropagation();const active=zoom.closest('dialog').classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(active));}
}, true);
}
